import { render, staticRenderFns } from "./AuthAreaLink.vue?vue&type=template&id=5c2a8d98&"
import script from "./AuthAreaLink.vue?vue&type=script&lang=ts&"
export * from "./AuthAreaLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports